import './index.sass';

export default () => {
  $('.js-search-clear').on('click', () => {
    $('.js-search-input').val('').focus();
  });

  $('.js-search-form').find('.js-search-input').on('input propertychange', function() {
    var $form, $submitBtn;
    $form = $(this).closest('.js-search-form');
    $submitBtn = $form.find('.js-search-submit');
    if ($(this).val().length > 0) {
      return $submitBtn.removeAttr('disabled');
    } else {
      return $submitBtn.attr('disabled', 'disabled');
    }
  });
}